import { useState } from "react";
import ReactDOM from "react-dom/client";
import React from "react";
import classes from "./LoginForm.module.css";
import DarkModeContext from "../../store/DarkModeContext";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import serverPostData from "../../utils/ServerPostData";
import AuthContext from "../../store/AuthContext";
import { Route, Navigate, NavLink, useNavigate } from "react-router-dom";

function LoginForm() {
  const darkModeCtx = useContext(DarkModeContext);
  const isDark = darkModeCtx.darkMode;
  const [tg, i18n] = useTranslation("global");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const authCtx = useContext(AuthContext);
  const isAuth = authCtx.auth;
  const navigate = useNavigate();
  const userId = authCtx.userId;
  const userAdmin = authCtx.userAdmin;
  const formData = new FormData();

  //const { logIn } = useUserAuth();

  const handleAuthAccept = () => {
    
    authCtx.authTrue(2);
    navigate('/objectives');  
    console.log("clicked button -> " + authCtx.auth);
  };

  const handleAuthUserAdminAccept = () => {
    authCtx.authTrue(1);
    console.log("clicked button -> " + authCtx.userAdmin);
  }

  const handleAtributeUser = (data) => {
    authCtx.setUserId(data.Id);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setEmailError("");
    setPasswordError("");

    if ("" === email) {
      setEmailError(tg("login.credentials_error.no_email"));
      return;
    }

    if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      setEmailError(tg("login.credentials_error.invalid_email"));
      return;
    }

    if ("" === password) {
      setPasswordError(tg("login.credentials_error.no_password"));
      return;
    }

    if (emailError === "" && passwordError === "")
      console.log(
        `The email you entered was: ` +
          email +
          ` and the password is: ` +
          password
      );

    formData.append("email", email);
    formData.append("password", password);

    const serverResponse = serverPostData(
      "/dashboard-login-credentials",
      formData
    );

    serverResponse.then((response) => {
      let data = response;

      if (data.status === 200) {
        alert("Login successful!");

        
        navigate('/');
     
        handleAuthAccept();
        handleAtributeUser(data.data);
        console.log("clicked button -> " + authCtx.auth);
        console.log("userId -> " + authCtx.userId);

        //alert()
      }
      else if (data.status === 201) {

        navigate('/');
        alert("USER ADMIN");
        handleAuthUserAdminAccept();
        handleAtributeUser(data.data);
        console.log("clicked button -> " + authCtx.userAdmin);
        console.log("userId -> " + authCtx.userId);

        
      } else if (data.status === 403) {
        alert("Unauthorized access");
      } else if (data.status === 401) {
          alert("Incorrect email or password");
      } else {
        alert("Server error");
        alert(data.status);
      }
    });

    //console.log(`Server response: ` + serverResponse.then((data) => console.log(data)));
    console.log(
      `Server response: ` +
        serverResponse.then((data) => console.log(data.status))
    );
  };

  return (
    <form id="login" onSubmit={handleSubmit} style={{marginTop:'5rem'}}>
      <label className={classes.titleContainer}>{tg("login.titles.main_title")}</label>
        <input
          className={classes.inputBox}
          type="text"
          placeholder={tg("login.labels.email")}
          name="fname"
          onChange={(e) => setEmail(e.target.value)}
        />
        <br />
      <br />
      <label className={classes.errorLabel}>{emailError}</label>
      <br />
        <input
          className={classes.inputBox}
          type="password"
          placeholder={tg("login.labels.password")}
          name="fname"
          onChange={(e) => setPassword(e.target.value)}
        />
        <br />
        <label className={classes.errorLabel}>{passwordError}</label>
        <br />
      <input
        type="submit"
        className={classes.button}
        value={tg("login.buttons.submit")}
      />
      <br />
    </form>
  );
}

export default LoginForm;




